import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

// labelPlacement: "top","start","bottom","end",
export default function Check({ register, ...props }) {
  return (
    <FormControlLabel
      defaultChecked={props.defaultChecked}
      label={props.label}
      disabled={props.disabled}
      control={<Checkbox {...register} color={props.color} />}
      labelPlacement={props.labelPlacement}
      checked={props.checked}
      onChange={props.onChange}
    />
  );
}
